import React, { FC, useEffect, useState } from "react";
import { SearchResultItem } from "./SearchResultItem";
import { SearchResultItemViewModel } from "./SearchResultItemViewModel.csharp";
import { LoadingAnimation } from "../LoadingAnimation/LoadingAnimation";

interface SearchResultsProps {
  query: string;
  items: SearchResultItemViewModel[];
  totalResults: number;
  fetchSearchData: () => void;
  loading: boolean;
}

export const SearchResults: FC<SearchResultsProps> = ({
  query,
  loading,
  items,
  fetchSearchData,
  totalResults,
}) => {
  useEffect(() => {
    fetchSearchData();
  }, []);

  return (
    <>
      {items && items.length > 0 && (
        <div>
          {items.map((item, i) => (
            <article className="mb-2" key={i}>
              <SearchResultItem {...item} />
            </article>
          ))}
          {items.length < totalResults && (
            <button className={"btn btn-primary"} onClick={fetchSearchData}>
              {loading ? <LoadingAnimation text={"Vis mer"} /> : "Vis mer"}
            </button>
          )}
        </div>
      )}

      {!loading && items && items.length == 0 && (
        <div className="SearchResults">
          Fant ingen resultater for <span>"{query}"</span>
        </div>
      )}
    </>
  );
};
